import {
  Award,
  Car,
  Gem,
  Heart,
  ShieldCheck,
  Sparkles,
  Zap,
  UserCheck,
} from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Reveal, SectionKicker } from "./Reveal";

const ICONS = { Award, Car, Gem, Heart, ShieldCheck, Sparkles, Zap, UserCheck };

export const WhyChooseUs = () => {
  const { t } = useLang();
  const w = t.why;

  return (
    <section
      id="por-que"
      data-testid="why-section"
      className="py-24 sm:py-32 bg-[#0a0a0a] border-y border-white/5"
    >
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <SectionKicker>{w.kicker}</SectionKicker>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            {w.title}
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {w.items.map((item, i) => {
            const Icon = ICONS[item.icon] || Award;
            return (
              <Reveal key={item.title} delay={(i % 4) * 0.06}>
                <div
                  data-testid={`why-card-${i}`}
                  className="group h-full rounded-2xl border border-white/10 bg-[#0d0d0d] p-6 transition-all duration-300 hover:border-brand/50 hover:-translate-y-1"
                >
                  <div className="h-12 w-12 rounded-xl bg-brand/10 grid place-items-center transition-colors group-hover:bg-brand">
                    <Icon className="h-6 w-6 text-brand transition-colors group-hover:text-white" />
                  </div>
                  <h3 className="mt-5 font-heading text-lg font-semibold text-white">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-zinc-400 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
